// extracted by mini-css-extract-plugin
export default {"file-name":"file-name_file-name__vepuz","file-name__icon":"file-name_file-name__icon__x98q9","file-name__label":"file-name_file-name__label__4aG-u"};